var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ctk-item-header',{staticClass:"ctk-notifications-dialog-item-header"},[_c('div',{staticClass:"tw-my-auto",domProps:{"textContent":_vm._s(_vm.$t('app.paragraphs.shipment_ref', {
      reference: _vm.shipment.reference
    }))}})])}
var staticRenderFns = []

export { render, staticRenderFns }